import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnChanges {

  @Input()
  english: boolean;

  currentPage: any;

  // *** Content *** //

  solutions: string;
  about: string;
  contact: string;


  // ***************************** //

  constructor() { }

  ngOnChanges (changes: SimpleChanges) {
    this.initContent(changes.english.currentValue)
  }

  initContent(b: boolean) {
    if (b) {
      this.solutions = 'Solutions';
      this.about = 'About';
      this.contact = 'Contact';
    } else {
      this.solutions = 'Solutions';
      this.about = 'A Propos';
      this.contact = 'Contact';
    }
  }
}
